<script lang="ts">
  import type { TimelineEvent, EventStatus, EventType } from '../types/debugger';

  let { event, selected = false, onselect }: {
    event: TimelineEvent;
    selected?: boolean;
    onselect?: (id: string) => void;
  } = $props();

  const statusColors: Record<EventStatus, string> = {
    SUCCESS: 'bg-success',
    FAILED: 'bg-error',
    IN_PROGRESS: 'bg-accent animate-pulse-orange',
    PENDING: 'bg-text-muted',
    SKIPPED: 'bg-warning',
  };

  const typeBadgeColors: Record<EventType, string> = {
    DISCOVERY: 'bg-info/20 text-info',
    ADOPTION: 'bg-success/20 text-success',
    CADENCE: 'bg-accent/20 text-accent',
    DISABLE: 'bg-warning/20 text-warning',
    ERROR: 'bg-error/20 text-error',
    LIFECYCLE: 'bg-reasoning/20 text-reasoning',
  };

  function formatTime(ts: string): string {
    return new Date(ts).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  }
</script>

<button
  onclick={() => onselect?.(event.id)}
  class="w-full text-left px-3 py-2.5 transition-all duration-150 border-l-[3px] group
    {selected ? 'border-l-accent bg-accent-light animate-pulse-orange' : 'border-l-transparent hover:bg-bg-hover hover:scale-[1.01] hover:shadow-md hover:shadow-black/10'}"
>
  <div class="flex items-start gap-2.5">
    <!-- Status Dot -->
    <div class="mt-1.5 shrink-0">
      <div class="w-2 h-2 rounded-full {statusColors[event.status]}"></div>
    </div>

    <div class="flex-1 min-w-0">
      <!-- Type Badge + Time -->
      <div class="flex items-center justify-between gap-2 mb-1">
        <span class="text-[10px] font-medium px-1.5 py-0.5 rounded-full {typeBadgeColors[event.type]}">
          {event.type}
        </span>
        <span class="text-[10px] text-text-muted shrink-0">{formatTime(event.timestamp)}</span>
      </div>

      <!-- Title -->
      <p class="text-xs font-medium text-text-primary truncate leading-snug">{event.title}</p>

      <!-- Description -->
      {#if event.description}
        <p class="text-[11px] text-text-secondary truncate mt-0.5">{event.description}</p>
      {/if}

      <!-- Duration -->
      {#if event.duration}
        <span class="text-[10px] text-text-muted mt-1 inline-block">{event.duration}ms</span>
      {/if}
    </div>
  </div>
</button>
